var _path, _path2, _circle, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg93434801581665209(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.6 38.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M4.4 2.3c-1.1 0-2.1.9-2.1 2.1v30.3c0 1.1.9 2.1 2.1 2.1h17.7c1.1 0 2.1-.9 2.1-2.1V4.4c0-1.1-.9-2.1-2.1-2.1H4.4zm8.8 32.4c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm7.7-4H5.5V5.1h15.4v25.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.9 30.7V5.1H5.5v25.6h15.4zm-7.8-12.8h-3v-1.1h3v1.1zm.2 0v-1.1h3v1.1h-3zm.2 5.1h3.1v.8h-3.1V23zm6 4.1h-6v-.8h6v.8zm0-1.4h-6v-.8h6v.8zm0-3.2h-6v-.8h6v.8zm0-1.4h-6v-.8h6v.8zm0-1.3h-6V19h6v.8zm-3-1.9v-1.1h3v1.1h-3zM7 6.7h12.5v9.2H7V6.7zm0 10h3v1.1H7v-1.1zm0 2.2h5.8v5.4H7v-5.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 13.2,
    cy: 33.4,
    r: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M7 6.7h12.5v9.2H7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M7 16.7h3v1.1H7zM7 18.9h5.8v5.4H7zM10.2 16.7h3v1.1h-3zM13.3 16.7h3v1.1h-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M13.5 19h6v.8h-6zM13.5 20.3h6v.8h-6zM13.5 21.7h6v.8h-6zM13.5 23h3.1v.8h-3.1zM13.5 24.9h6v.8h-6zM13.5 26.3h6v.8h-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M16.5 16.7h3v1.1h-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg93434801581665209);
export default __webpack_public_path__ + "static/media/93434801581665209.3521de56be6b12b3f1dd0a088b8d3c45.svg";
export { ForwardRef as ReactComponent };